import api from "./api";

/**
 * Workforce API client. Thin wrapper so pages stay slim.
 */
export const workforceApi = {
  // Catalog
  listBrains: () => api.get("/workforce/brains").then((r) => r.data),
  listProviders: () => api.get("/workforce/providers").then((r) => r.data),
  listToolsCatalog: () => api.get("/workforce/tools/catalog").then((r) => r.data),

  // Workers
  listWorkers: () => api.get("/workforce/workers").then((r) => r.data),
  createWorker: (body) => api.post("/workforce/workers", body).then((r) => r.data),
  getWorker: (id) => api.get(`/workforce/workers/${id}`).then((r) => r.data),
  updateWorker: (id, body) => api.patch(`/workforce/workers/${id}`, body).then((r) => r.data),
  swapBrain: (id, brain_id, extra = {}) =>
    api.post(`/workforce/workers/${id}/brain`, { brain_id, ...extra }).then((r) => r.data),
  deleteWorker: (id) => api.delete(`/workforce/workers/${id}`).then((r) => r.data),

  // Chat
  getMessages: (id) => api.get(`/workforce/workers/${id}/messages`).then((r) => r.data),
  clearConversation: (workerId, convId) =>
    api.delete(`/workforce/workers/${workerId}/conversations/${convId}`).then((r) => r.data),

  // Memory
  listMemory: (id) => api.get(`/workforce/workers/${id}/memory`).then((r) => r.data),
  addMemory: (id, body) => api.post(`/workforce/workers/${id}/memory`, body).then((r) => r.data),
  deleteMemory: (id, mid) => api.delete(`/workforce/workers/${id}/memory/${mid}`).then((r) => r.data),

  // Activity
  getWorkerActivity: (id) => api.get(`/workforce/workers/${id}/activity`).then((r) => r.data),
  getGlobalActivity: () => api.get("/workforce/activity").then((r) => r.data),

  // Analytics
  analyticsSummary: () => api.get("/workforce/analytics/summary").then((r) => r.data),
};
